import {
  PushpinFilled,
  ThunderboltFilled,
  ThunderboltOutlined,
} from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';

import { DoubleThunderbolt } from 'app/components/commons/DoubleThunderbolt/DoubleThunderbolt';

import type { InventoryBadge as InventoryBadgeType } from '../../utils/badges';

import styles from './InventoryBadge.module.scss';

type Props = {
  badge: InventoryBadgeType;
};

export const InventoryBadge: React.FC<Props> = ({ badge }) => {
  const colorClass = styles[`badge__color--${badge.color}`];

  switch (badge.type) {
    case 'autoInventory':
      return (
        <Tooltip title={badge.tooltip} placement="bottom">
          <div className={styles.badge}>
            {badge.variant === 'active' ? (
              <span
                className={classNames(styles['badge__dot--active'], colorClass)}
              >
                •
              </span>
            ) : (
              <span
                className={classNames(
                  styles['badge__dot--deactivated'],
                  colorClass
                )}
              >
                ○
              </span>
            )}
          </div>
        </Tooltip>
      );

    case 'pricingRule':
      return (
        <Tooltip title={badge.tooltip} placement="bottom">
          <div className={styles.badge}>
            {badge.variant === 'lastMinute' && (
              <span
                className={classNames(
                  styles['badge__thunder--active'],
                  colorClass
                )}
              >
                <DoubleThunderbolt />
              </span>
            )}
            {badge.variant === 'default' && (
              <span
                className={classNames(
                  styles['badge__thunder--active'],
                  colorClass
                )}
              >
                <ThunderboltFilled />
              </span>
            )}
            {badge.variant === 'deactivated' && (
              <span
                className={classNames(
                  styles['badge__thunder--deactivated'],
                  colorClass
                )}
              >
                <ThunderboltOutlined />
              </span>
            )}
          </div>
        </Tooltip>
      );

    case 'manualEdit':
      return (
        <Tooltip title={badge.tooltip} placement="bottom">
          <div className={styles.badge}>
            <span className={classNames(styles.badge__pin, colorClass)}>
              <PushpinFilled />
            </span>
          </div>
        </Tooltip>
      );
  }
};

type ListProps = {
  badges: InventoryBadgeType[];
};

export const InventoryBadges: React.FC<ListProps> = ({ badges }) => (
  <div className={styles.badges}>
    {badges.map((badge) => (
      <InventoryBadge key={badge.type} badge={badge} />
    ))}
  </div>
);
